import RestResource from '../rest.service';
import Service from '../api.service';

export default class UsersService extends RestResource {
  map(payload) {
    return {
      name: payload.name,
      email: payload.email,
      role: payload.role,
      active: payload.active,
    };
  }

  invite(id) {
    return Service.patch(`users/${id}/invite`).catch(this.handleErrors);
  }

  constructor() {
    super('users');
  }
}
